<script>
    import OPTS from '../../libs/options';
    import API from "../../libs/api";

    export let id;
    export let title;
    export let level;
    export let fund;
    export let libro;
    export let date;
    export let link;
    export let bookmarked; // values "y", "n", "u"
    export let hasImages = false;

    $: fullLink = `${OPTS.link_url}/${link}.html`;

    async function bookmarkHandler() {
        if (bookmarked === 'u') {
            window.location.href = window.contextPath + '/profilo/accesso.html';
        } else if (bookmarked === 'y') {
            await API.removeBookmark(id);
            bookmarked = 'n'
        } else if (bookmarked === 'n') {
            await API.addBookmark(id);
            bookmarked = 'y'
        }
    }
</script>
<a href="{fullLink}" class="c-result-tile">
    <div class="c-result-tile__header">
        <p class="c-result-tile__type">
            <i class="fas" class:fa-camera-alt={hasImages} class:fa-file-alt={!hasImages}></i>
            <span>{level}</span>
        </p>
        <button on:click|preventDefault={bookmarkHandler}
                class="c-result-tile__bookmark c-bookmark-button"
                class:c-bookmark-button--bookmarked={bookmarked === 'y'}
                title={bookmarked === 'y' ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 class="c-bookmark-button__svg" role="img" aria-hidden="true" viewBox="0 0 512 512"
                 width="24" height="24" fill="none">
                <path class="c-bookmark-button__fill"
                      d="M256.419,464.189c-4.331,0-8.477-1.756-11.491-4.866l-193.6-199.8c-23.723-24.465-36.884-60.191-35.202-95.564   c1.645-34.574,17.276-66.163,44.015-88.948c21.13-18.045,45.227-27.201,71.607-27.201c37.731,0,73.932,19.967,93.071,39.755   l31.199,32.222l31.206-32.228c19.009-19.664,55.221-39.515,93.252-39.515c26.38,0,50.407,9.072,71.416,26.964   c26.691,22.737,42.309,54.283,43.977,88.828c1.708,35.39-11.432,71.157-35.15,95.677L267.933,459.3   c-3.012,3.12-7.16,4.885-11.497,4.89C256.431,464.189,256.424,464.189,256.419,464.189z"></path>
                <path class="c-bookmark-button__stroke"
                      d="M131.748,63.811c35.046,0.004,66.563,19.362,81.571,34.879l42.7,44.1l42.7-44.1c14.783-15.293,46.535-34.645,81.757-34.645   c20.054,0,41.234,6.275,61.043,23.145c54,46,46.1,121.5,7.7,161.2l-192.8,199.8l-193.6-199.8c-38.4-39.6-46.4-115.1,7.7-161.2   C90.47,70.151,111.684,63.809,131.748,63.811 M131.739,31.811c-29.865,0-58.22,10.735-82.001,31.045   C19.623,88.517,2.001,124.161,0.144,163.199c-1.889,39.708,12.953,79.883,39.701,107.467l193.592,199.791   c6.028,6.221,14.32,9.732,22.981,9.732c0.011,0,0.022,0,0.033,0c8.673-0.009,16.971-3.538,22.994-9.78l192.8-199.8   c26.707-27.611,41.522-67.825,39.604-107.546c-1.883-39.005-19.491-74.602-49.581-100.234   c-23.649-20.141-51.932-30.785-81.793-30.785c-20.547,0-42.087,5.08-62.29,14.691c-16.418,7.81-31.503,18.363-42.475,29.714   l-19.692,20.338L236.308,76.43c-19.899-20.573-59.232-44.614-104.557-44.619h0C131.748,31.811,131.742,31.811,131.739,31.811   L131.739,31.811z"></path>
            </svg>
        </button>
    </div>
    <div class="c-result-tile__content">
        <h5 class="c-result-tile__title">{title}</h5>
        <div class="c-result-tile__separator"></div>
        <div class="c-result-tile__additional-info">
            <p class="c-result-tile__info">{date}</p>
            {#if libro}
                <p class="c-result-tile__info">{libro}</p>
            {/if}
        </div>
    </div>
    <div class="c-result-tile__footer">
        <p class="c-result-tile__fund">Fondo {fund}</p>
    </div>
</a>